import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import "./UserProfile.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import defaultProfile from '../../assets/defaultProfile.png';
import { useAuth } from '../AuthContext';
import Loader from "../../components/Loader";
import Navbar from "../../components/navigationbar/Navbar";
import Footer from "../../components/Footer/Footer";

const UserProfile = () => {
  const [user, setUser] = useState(null);
  const [editingMode, setEditingMode] = useState(false);
  const [editFormValues, setEditFormValues] = useState({
    firstName: "",
    lastName: "",
    bio: "",
    profileImages: [],
    registrationNumber: ""|| null,
    phone: "",
    // email: "",
    address: ""||null,
    certificateImages: [],
  });

  const [imageFile, setImageFile] = useState(null);
  const [uploadProgressimg, setUploadProgressimg] = useState(0);
  const [uploadProgress, setUploadProgress] = useState({});
  const [loading, setLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);  // Modal state for displaying enlarged image

  const navigate = useNavigate();
  // const { userId } = useParams();
  const { logout } = useAuth();

  const location = useLocation();
  const { username } = location.state || '';
  const userId = username;
  useEffect(() => {
    const fetchUserById = async () => {
      if (userId) {
        try {
          const docRef = doc(db, "users", userId);
          const userDocSnapshot = await getDoc(docRef);
          if (userDocSnapshot.exists()) {
            const userDocumentData = userDocSnapshot.data();
            setUser({ ...userDocumentData, uid: userId });
            setEditFormValues({
              ...userDocumentData,
              profileImages: userDocumentData.profileImages || [],
              certificateImages: userDocumentData.certificateImages || [],
            });
          } else {
            console.error("No such document!");
            navigate("/login");
          }
        } catch (error) {
          console.error("Error fetching user document:", error);
        } finally {
          setLoading(false);
        }
      } else {
        console.error("No userId found, redirecting to login.");
        navigate("/login");
      }
    };

    fetchUserById();
  }, [navigate, userId]);

  const toggleEditingMode = () => {
    setEditingMode(!editingMode);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEditFormValues({
      ...editFormValues,
      [name]: value,
    });
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
      updateProfileImage(event.target.files[0]);
    } else {
      toast.error("No file selected");
    }
  };

  const updateProfileImage = async (file) => {
    if (!file) {
      toast.error("No file selected for upload");
      return;
    }

    const storageRef = ref(storage, `users/${userId}/profileImages/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgressimg(progress);
      },
      (error) => {
        console.error("Upload error:", error);
        toast.error("Upload failed");
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          const updatedProfileImages = [...editFormValues.profileImages, downloadURL];
          await updateDoc(doc(db, "users", userId), {
            profileImages: updatedProfileImages,
          });
          setEditFormValues({
            ...editFormValues,
            profileImages: updatedProfileImages,
          });
          toast.success("Profile image updated successfully");
        });
      }
    );
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    const updatedCertificateImages = [...editFormValues.certificateImages];
    const uploadProgressTemp = { ...uploadProgress };

    Array.from(files).forEach((file, index) => {
      const storageRef = ref(storage, `users/${userId}/certificates/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          uploadProgressTemp[file.name] = progress;
          setUploadProgress(uploadProgressTemp);
        },
        (error) => {
          console.error("Upload error:", error);
          toast.error("Upload failed");
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          updatedCertificateImages.push(downloadURL);

          await updateDoc(doc(db, "users", userId), {
            certificateImages: updatedCertificateImages,
          });

          setEditFormValues({
            ...editFormValues,
            certificateImages: updatedCertificateImages,
          });

          toast.success("File uploaded successfully");
        }
      );
    });
  };

  const deleteCertificateImage = async (index) => {
    const imageUrl = editFormValues.certificateImages[index];
    const imageRef = ref(storage, imageUrl);

    try {
      await deleteObject(imageRef);
      const updatedCertificateImages = [...editFormValues.certificateImages];
      updatedCertificateImages.splice(index, 1);
      await updateDoc(doc(db, "users", userId), {
        certificateImages: updatedCertificateImages,
      });
      setEditFormValues({
        ...editFormValues,
        certificateImages: updatedCertificateImages,
      });
      toast.success("Certificate image deleted successfully");
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete certificate image");
    }
  };

  const handleSaveChanges = async () => {
    try {
      await updateDoc(doc(db, "users", userId), {
        firstName: editFormValues.firstName,
        lastName: editFormValues.lastName,
        bio: editFormValues.bio,
        profileImages: editFormValues.profileImages,
        registrationNumber: editFormValues.registrationNumber,
        phone: editFormValues.phone,
        // email: editFormValues.email,
        address: editFormValues.address,
        certificateImages: editFormValues.certificateImages,
      });

      setUser({
        ...user,
        ...editFormValues,
      });

      setEditingMode(false);
      toast.success("Profile updated successfully");
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile");
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Navbar />
      <div className="user-profile-container">
        <div className="nav-container"></div>
        <ToastContainer />
        <div className="user-profile-header">
          {/* <h2 style={{ fontWeight: '600' }}>Hello {user?.firstName} </h2> */}
          <div>
          <button className="edit-btn" onClick={toggleEditingMode}>
            {editingMode ? "Cancel" : "Edit Profile"}
          </button>
          </div>
          <div>

            <button className="logout-btn" onClick={logout}>Logout</button>
          </div>
        </div>

        <div className="user-profile-continer-box">
         
          <div className="user-profile-info">

            <div className="profile-image-maincontainer">
              <div className="profile-image-container">
                <img
                  src={editFormValues.profileImages.length > 0 ? editFormValues.profileImages[editFormValues.profileImages.length - 1] : defaultProfile}
                  alt="Profile"
                  className="profile-image"
                />
                {editingMode && (
                  <>
                    <label className="custom-file-input">
                      <i className="fas fa-camera"></i>
                      <input type="file" onChange={handleImageChange} />
                    </label>
                    {/* <progress value={uploadProgressimg} max="100" className="progress-bar" /> Progress bar for profile image upload */}
                  </>
                )}
              </div>
            </div>
            <div>

              <div className="info-row">
              <label> Unique ID:</label>
                <span>{user.uniqueId? user.uniqueId :"Not Registered"}</span>
              </div>

              <div className="info-row">
                <label> Name:</label>
                {editingMode ? (
                  <div>
               
                  <input type="text" name="firstName"  placeholder='first name' value={editFormValues.firstName} onChange={handleInputChange} />
                  <input type="text" name="middleName" placeholder="middle name" value={editFormValues.middleName} onChange={handleInputChange} />
                  <input type="text" name="lastName" lastName='last name' value={editFormValues.lastName} onChange={handleInputChange} />
                  </div>
                ) : (
                  <span>Dr. {user.firstName + " "+user.middleName+" "+user.lastName }</span>
                )}
              </div>

              <div className="info-row">
                <label>bio:</label>
                {editingMode ? (
                  <textarea name="bio" value={editFormValues.bio} onChange={handleInputChange} />
                ) : (
                  <span>{user.bio}</span>
                )}
              </div>

              <div className="info-row">
                <label>Registration Number:</label>
                {editingMode ? (
                  <input type="text" name="registrationNumber" value={editFormValues.registrationNumber} onChange={handleInputChange} />
                ) : (
                  <span>{user.registrationData? user.registrationData.registrationNumber:"Not Registerd"}</span>
                )}
              </div>

              <div className="info-row">
                <label>Phone:</label>
                {editingMode ? (
                  <input type="text" name="phone" value={editFormValues.phone} onChange={handleInputChange} />
                ) : (
                  <span>{user.phone}</span>
                )}
              </div>

              <div className="info-row">
                <label>Email:</label>
                {false ? (
                  <input type="text" name="email" value={editFormValues.email} onChange={handleInputChange} />
                ) : (
                  <span>{user.registrationData? user.registrationData.email:"Not Registerd"}</span>
                )}
              </div>

              <div className="info-row">
                <label>Address:</label>
                {editingMode ? (
                  <textarea name="address" value={editFormValues.address} onChange={handleInputChange} />
                ) : (
                  <span>{user.registrationData? user.registrationData.address1: "Not Registerd"}
                          
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Instagram-like grid layout for certificates */}
          <div className="certificate-container">
            <h3>Certificates:</h3>
            <div className="certificate-grid">
              {editFormValues.certificateImages.map((imageUrl, index) => (
                <div key={index} className="certificate-post">
                  <img
                    src={imageUrl}
                    alt={`Certificate ${index + 1}`}
                    className="certificate-image"
                    onClick={() => setModalImage(imageUrl)}  // Set modal image on click
                  />
                  {editingMode && (
                    <button onClick={() => deleteCertificateImage(index)} className="delete-btn">Delete</button>
                  )}
                </div>
              ))}
            </div>
            {editingMode && (
              <>
                <label className="custom-file-input-certificate">
                  <i className="fas fa-upload"></i> Upload Certificates
                  <input type="file" multiple onChange={handleFileChange} />
                </label>
                {Object.keys(uploadProgress).map((fileName) => (
                  <progress key={fileName} value={uploadProgress[fileName]} max="100" className="progress-bar" />
                ))}
              </>
            )}
          </div>
        </div>

        {editingMode && (
          <div className="save-changes-container">
            <button onClick={handleSaveChanges}>Save Changes</button>
          </div>
        )}

        {/* Modal for enlarged certificate image */}
        {modalImage && (
          <div className="modal" onClick={() => setModalImage(null)}>
            <span className="close-modal">&times;</span>
            <img src={modalImage} alt="Enlarged Certificate" className="modal-content" />
          </div>
        )}
      </div>
      <Footer />
    </>


  );
};

export default UserProfile;
